// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".equipment-image-delete-modal .group-edit-image {\n  max-width: 600px !important;\n}", ""]);
// Exports
module.exports = exports;
